import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { HoneConnectLogo, HoneConnectLogoII } from "../../../assets/img";
import { SITELINKS } from "../../../app-routes/links";
import { Menu, X } from "lucide-react";

const WebsiteHeader = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState("home");

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      setIsOpen(false);
      setActive(id)
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="bg-honeConnectPurple md:bg-white sticky top-[-2px] z-20 py-4 sm:py-5 px-5 md:py-0 md:px-0 shadow sm:border-b">
      {/* Desktop NavBar & Menu*/}
      <div className="hidden md:flex justify-between items-center 2xl:w-9/12 xl:w-11/12 md:w-11/12 mx-auto">
        <div className="py-2">
          <Link to="/">
            <img src={HoneConnectLogo} alt="app logo" className="h-[50px]" />
          </Link>
        </div>

        <div className="flex items-center 2xl:gap-x-20 xl:gap-x-10 md:gap-x-10 text-sm">
          <ul className="hidden md:flex gap-12 font-medium text-gray-800">
            <li className="relative">
              <Link to={'/'}
                className={`${
                  active === "home"
                    ? "after:content-[''] after:absolute after:left-1 after:bottom-[-23px] after:w-3/4 after:h-[3px] after:bg-honeConnectPurple after:rounded-t-full text-honeConnectPurple font-bold"
                    : "after:content-[''] after:absolute after:left-0 after:bottom-[-23px] after:w-full after:h-[3px] after:bg-honeConnectPurple after:rounded-t-full after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100"
                }`}
                type="button"
                onClick={() => scrollToSection("home")}
              >
                Home
              </Link>
            </li>

            <li className="relative">
              <Link to={'/'}
                className={`${
                  active === "benefit"
                    ? "after:content-[''] after:absolute after:left-2 after:bottom-[-23px] after:w-3/4 after:h-[3px] after:bg-honeConnectPurple after:rounded-t-full text-honeConnectPurple"
                    : "after:content-[''] after:absolute after:left-0 after:bottom-[-23px] after:w-full after:h-[3px] after:bg-honeConnectPurple after:rounded-t-full after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100"
                }`}
                type="button"
                onClick={() => scrollToSection("benefit")}
              >
                Our Benefits
              </Link>
            </li>

            <li className="relative">
              <Link to={'/'}
                className={`${
                  active === "faq"
                    ? "after:content-[''] after:absolute after:left-1 after:bottom-[-23px] after:w-3/4 after:h-[3px] after:bg-honeConnectPurple after:rounded-t-full text-honeConnectPurple"
                    : "after:content-[''] after:absolute after:left-0 after:bottom-[-23px] after:w-full after:h-[3px] after:bg-honeConnectPurple after:rounded-t-full after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100"
                }`}
                type="button"
                onClick={() => scrollToSection("faq")}
              >
                FAQs
              </Link>
            </li>

            <li className="relative hidden lg:block">
              <a
                href="/terms-and-conditions"
                className={`${
                  active === "tnc"
                    ? "after:content-[''] after:absolute after:left-0 after:bottom-[-23px] after:w-full after:h-[3px] after:bg-honeConnectPurple after:rounded-t-full text-honeConnectPurple"
                    : "after:content-[''] after:absolute after:left-0 after:bottom-[-23px] after:w-full after:h-[3px] after:bg-honeConnectPurple after:rounded-t-full after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100"
                }`}
                type="button"
                onClick={() => scrollToSection("faq")}
              >
                Terms & Conditions
              </a>
            </li>
          </ul>

          <div>
            <button
              onClick={() => {
                localStorage.clear();
                navigate(SITELINKS.LOGIN);
              }}
              className="py-2 px-6 font-semibold text-white rounded-lg text-sm bg-honeConnectPurple hover:bg-purple-700 hover:shadow-xl"
            >
              Sign In
            </button>
          </div>
        </div>
      </div>

      {/* Mobile NavBar & Menu */}
      <div className="md:hidden">
        <div className="flex justify-between">
          {/* logo Mobile */}
          <div>
            <Link to="/">
              <img
                src={HoneConnectLogoII}
                alt="app logo"
                className="h-[40px] rounded-md"
              />
            </Link>
          </div>

          <button onClick={toggleNavbar}>
            {isOpen ? (
              <X size={40} color="white" />
            ) : (
              <Menu size={40} color="white" />
            )}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="flex flex-col text-center gap-8 text-sm py-10">
          {/* NAV LINKS */}
          <ul className="flex flex-col gap-8 font-medium text-white">
            <li onClick={toggleNavbar}>
              <button type="button" onClick={() => scrollToSection("home")}>
                Home
              </button>
            </li>

            <li onClick={toggleNavbar}>
              <button type="button" onClick={() => scrollToSection("benefit")}>
                Our Benefits
              </button>
            </li>

            <li onClick={toggleNavbar}>
              <button type="button" onClick={() => scrollToSection("faq")}>
                FAQs
              </button>
            </li>
          </ul>
          {/* NAV SIGN IN */}
          <div className="px-6">
            <Link
              to={SITELINKS.LOGIN}
              className="py-3 w-full shadow font-medium text-honeConnectPurple rounded-[10px] bg-white border border-solid border-white hover:bg-honeConnectPurple hover:border-white hover:text-white block"
            >
              Sign In
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
export default WebsiteHeader;
